/**
 * Puts the rows a save returned into the field list already on screen.
 *
 * A save answers with the rows it wrote. The full list only comes back from a fresh read of the CRM,
 * which takes seconds, and until it arrives the screen would go on showing each row as it was before
 * the save: a confirmed match reading "check this match" again. Merging the answer in closes that
 * gap. The fresh read still follows and replaces this.
 *
 * A rejected row is kept, not removed: it is what tells the screen the advisor chose to leave the
 * field unmapped. An answer with no rows changes nothing.
 */
import type { Prospecting } from '@client/api/types';

export function applySavedFieldMap(
  current: Prospecting.SchemaDiscoveryResponse | undefined,
  saved: Partial<Prospecting.ConfirmFieldMapResponse> | undefined,
): Prospecting.SchemaDiscoveryResponse | undefined {
  if (!current || !saved?.fieldMap?.length) return current;

  const written = new Map(saved.fieldMap.map(entry => [entry.canonicalField, entry]));
  const kept = current.fieldMap.filter(entry => !written.has(entry.canonicalField));

  return { ...current, fieldMap: [...kept, ...saved.fieldMap] };
}
